(() => {
  if (window.bigLivingSpecificationsInitialized) return;
  window.bigLivingSpecificationsInitialized = true;
  const cleanups = [];
  const reset = () => { while (cleanups.length) cleanups.pop()(); };
  const enhance = excluded => {
    reset();
    const main = document.getElementById('MainContent');
    if (!main) return;
    main.querySelectorAll('[data-big-specification-link]').forEach(link => link.remove());
    const products = Array.from(main.querySelectorAll('[id^="MainProduct-"]')).filter(node => !excluded?.contains(node));
    if (products.length !== 1) return;
    const product = products[0];
    const config = product.dataset;
    if (config.bigSpecificationsMode !== 'fallback') return;
    if (!config.bigSizeName || !config.bigSpecificationsHeading || !config.bigSpecificationsLabel || !config.bigSizeReturnLabel) return;
    const text = { details: config.bigSpecificationsLabel, back: config.bigSizeReturnLabel };
    const sizes = Array.from(product.querySelectorAll('variant-selects fieldset')).filter(field => {
      const legend = field.querySelector('legend');
      return legend && legend.textContent.trim().toLocaleLowerCase() === config.bigSizeName.toLocaleLowerCase();
    });
    const headings = Array.from(main.querySelectorAll('.multirow h2')).filter(heading => {
      const content = heading.parentElement.querySelector('.image-with-text__text:not(.image-with-text__text--caption)');
      return !excluded?.contains(heading) && heading.textContent.trim().toLocaleLowerCase() === config.bigSpecificationsHeading.toLocaleLowerCase() &&
        Boolean(product.compareDocumentPosition(heading) & Node.DOCUMENT_POSITION_FOLLOWING) &&
        content && content.textContent.trim().length > 0;
    });
    if (sizes.length !== 1 || headings.length !== 1) return;
    const size = sizes[0];
    const specs = headings[0];
    const identify = (node, id) => {
      if (node.id) return;
      node.id = id;
      cleanups.push(() => { if (node.id === id) node.removeAttribute('id'); });
    };
    identify(size, 'big-size-options-' + product.id);
    identify(specs, 'big-specifications-' + product.id);
    if (document.getElementById(size.id) !== size || document.getElementById(specs.id) !== specs) return;
    [size, specs].forEach(node => {
      if (node.classList.contains('big-size-target')) return;
      node.classList.add('big-size-target');
      cleanups.push(() => node.classList.remove('big-size-target'));
    });
    const addLink = (parent, target, label, modifier) => {
      const link = document.createElement('a');
      link.className = 'big-size-help' + modifier;
      link.setAttribute('data-big-specification-link', '');
      link.setAttribute('href', '#' + target.id);
      link.textContent = label;
      let frame = 0;
      const focusTarget = event => {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (!target.hasAttribute('tabindex')) {
          target.setAttribute('tabindex', '-1');
          cleanups.push(() => { if (target.getAttribute('tabindex') === '-1') target.removeAttribute('tabindex'); });
        }
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          if (target.isConnected) target.focus({ preventScroll: true });
        });
      };
      link.addEventListener('click', focusTarget);
      parent.append(link);
      cleanups.push(() => {
        cancelAnimationFrame(frame);
        link.removeEventListener('click', focusTarget);
        link.remove();
      });
    };
    addLink(size, specs, text.details, '');
    addLink(specs.parentElement, size, text.back, ' big-size-help--back');
  };
  const refresh = () => enhance();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else enhance();
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:reorder', refresh);
  document.addEventListener('shopify:section:unload', event => enhance(event.target));
})();
